import { render, staticRenderFns } from "./DocumentTypePicker.vue?vue&type=template&id=25f411d6"
import script from "./DocumentTypePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentTypePicker.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports